import {NgModule} from '@angular/core';
import {ComboBoxComponent} from './combo-box.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [
        ComboBoxComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ComboBoxComponent
    ],
    providers: []
})

export class BlitzBasicScriptComboBoxModule {
}
